export interface ReportData {
  name: any;
  value: any;
}

export interface ChartReportWithSeriesData {
  name: string;
  series: ReportData[];
}
